require("../app/production-page.coffee")
require("../app/advantages_slider.coffee")

window.pageInitFlag = false
pageInit = ->
  new window.ProductionPage()
  new window.AdvantagesSlider()

$(document).ready ->
  if window.pageInitFlag != true
    pageInit()
  window.pageInitFlag = true





// WEBPACK FOOTER //
// ./assets/javascripts/pages/production.coffee